<template>
  <div v-if="Array.isArray(content) && !$slots.default">
    <div
      v-for="(item, index) in content"
      :key="index"
      style="width: 600px"
    >
      {{ item.label }}
      <div class="flex items-center">
        <VueCodeHighlight style="width: 500px">
          <code>{{ item.code }}</code>
        </VueCodeHighlight>
        <q-btn
          icon="far fa-clone"
          size="15px"
          color="transparent"
          text-color="grey-10"
          class="action-icon q-ml-sm"
          padding="8px"
          flat
          @click="$emit('copy', item.code)"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <template v-if="!$slots.default">
      <div
        v-if="content"
        test-id="generated-text-block"
        class="typogarphy-generated-text"
        :style="cssProps"
        v-html="convertor()"
      />
    </template>
    <div
      v-else
      class="typogarphy-generated-text"
      :style="cssProps"
    >
      <slot/>
    </div>
  </div>
</template>

<script>
import markdownit from 'markdown-it';
import 'vue-code-highlight/themes/prism-twilight.css';
import { component as VueCodeHighlight } from 'vue-code-highlight';

export default {
  name: 'FormattedTextStyles',
  components: { VueCodeHighlight },
  props: {
    content: {
      type: [String, Array],
      default: '',
    },
    metaFields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    cssProps() {
      if (Object.keys(this.metaFields).length > 0) {
        return {
          '--design-color-background': this.metaFields.designColorBackground,
          '--design-color-hr': this.metaFields.designColorHR,
          '--design-color-link': this.metaFields.designColorLink,
          '--design-color-text': this.metaFields.designColorText,
          '--design-color-title': this.metaFields.designColorTitle,
        };
      }
    },
  },
  methods: {
    convertor() {
      if (this.content.includes('```')) {
        const md = markdownit({
          html: true,
        });
        return this.content.replace(/(```.*?```)/g, (match) => md.render(
          match.replaceAll('<br />', '\n')
            .replaceAll('```markdown', '')
            .replaceAll('```', ''),
        ));
      }
      return this.content;
    },
  },
};
</script>

<style scoped lang="scss">
.typogarphy-generated-text {
  font-style: normal !important;
  word-break: break-word;
  color: var(--design-color-text) !important;
  background-color: var(--design-color-background);

  @mixin font-style($size, $weight, $height) {
    font-size: $size !important;
    font-weight: $weight !important;
    line-height: $height !important;
  }
  ::v-deep() {
    * {
      max-width: 100%;
    }

    img {
      height: auto;
      border-radius: 20px;
    }
    h1 {
      @include font-style(32px, 700, normal)
    }
    h2 {
      @include font-style(24px, 700, normal)
    }
    h3 {
      @include font-style(20px, 700, normal)
    }
    h4 {
      @include font-style(18px, 700, normal)
    }
    h5 {
      @include font-style(16px, 700, normal)
    }
    h6 {
      @include font-style(14px, 700, normal)
    }
    h1, h2, h3, h4, h5 {
      color: var(--design-color-title);
      margin: 30px 0 !important;
      + *, + br + * {
        margin-top: 0 !important;
      }
    }
    a {
      color: var(--design-color-link) !important;
      text-decoration-line: underline !important;
    }
    hr {
      background-color: var(--design-color-hr);;
    }
    ul {
      li {
        margin-bottom: 20px !important;
        @include font-style(16px, 400, 27px);
      }
    }
    .femtexter-gpt-image {
      border-radius: 20px;
      width: 100%;
    }
    .femtexter-gpt-image-author {
      @include font-style(16px, 400, 30px);
      color: #A6A6A6;
      a {
        color: #4181E0;
      }
    }
    a span {
      text-decoration: underline;
    }
    table {
      border-spacing: 0;
      border-collapse: separate;
      border-radius: 10px;
      border: 1px solid $grey-7;
    }
    tr, th, td {
      padding: 5px 10px;
    }
    table th:not(:last-child),
    table td:not(:last-child) {
      border-right: 1px solid $grey-7;
    }
    table>thead>tr>th,
    table>thead>tr:not(:last-child)>td,
    table>tbody>tr:not(:last-child)>th,
    table>tbody>tr:not(:last-child)>td,
    table>tfoot>tr:not(:last-child)>th,
    table>tfoot>tr:not(:last-child)>td,
    table>tr:not(:last-child)>td,
    table>tr:not(:last-child)>th,
    table>thead:not(:last-child),
    table>tbody:not(:last-child),
    table>tfoot:not(:last-child) {
      border-bottom: 1px solid $grey-7;
    }
  }

  :deep(.iframe-wrapper) {
    border-radius: 20px;
    position: relative;
    padding-bottom: 56.25%;
    overflow: hidden;
    width: 100%;
    height: auto;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
